import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './JoinGameModal.css';
import ScalableWrapper from '@components/ScalableWrapper';
import View from '@components/View';
import Button from '@components/Button';
import OTPInput from 'react-otp-input';

interface JoinGameModalProps {
  isOpen: boolean;
  onClose: () => void;
  onJoinGame: (roomCode: string) => void;
}

const JoinGameModal: React.FC<JoinGameModalProps> = ({ isOpen, onClose, onJoinGame }) => {
  const [roomCode, setRoomCode] = useState('');
  
  const onChangeRoomCode = (code: string) => {
    setRoomCode(code);
  }

  const handleSubmit = (hashCode?: string) => {
      const code = roomCode || hashCode;
      onJoinGame(code!);
  }

  return (
    <>
      { isOpen && (
        <View className="join-game-modal-container" enableEventCapturing>
          <ScalableWrapper maintainAspectRatioBy="height">
            <View className="join-game-model-body">
              <motion.div
                className="join-game-modal"
                initial={{ y: '100%' }}
                animate={{ y: '0%' }}
                exit={{ y: '100%' }}
                transition={{ type: 'spring', stiffness: 500, damping: 30 }}
              >
                <Button className="close-button" onClick={onClose}>
                  &times;
                </Button>
                <h2 className='join-game-title'>Enter Room Code</h2>
                <View>
                    <OTPInput
                      value={roomCode}
                      onChange={onChangeRoomCode}
                      numInputs={4}
                      containerStyle={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        gap: 20,
                        pointerEvents: 'all',
                      }}
                      renderInput={(props) => (
                        <input {...props} className='room-code-input' />
                      )}
                    />
                </View>
                <Button className='submit-button' onClick={() => handleSubmit()} disabled={!(roomCode.length === 4)}>
                  Join
                </Button>
              </motion.div>
            </View>
          </ScalableWrapper>
        </View>
      )}
    </>
  );
};

export default JoinGameModal;